import React from 'react'

export const LoaderComponent = () => <i className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></i>
